module.exports = __webpack_public_path__ + "static/img/icon_visit_tab_sel.35f829a.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_visit_tab_sel.png
// module id = 5qzR
// module chunks = 1